/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
import { iToolTips, iCountry, iApiError } from '@interfaces/interfaces';

interface iVicFinesFormContext {
  apiError?: iApiError;
  countryList: iCountry[];
  tooltips: iToolTips;
  setCountryList: (_countryList: iCountry[]) => void;
  setTooltips: (_tooltips: iToolTips) => void;
  clearApiError?: () => void;
}

const context = {
  countryList: [] as iCountry[],
  tooltips: {} as iToolTips,
  setCountryList: (_countryList: iCountry[]): void => {},
  setTooltips: (_tooltips: iToolTips): void => {},
};

export const INITIAL_TP_CONTEXT: iVicFinesFormContext = {
  apiError: {} as iApiError,
  clearApiError: (): void => {},
  ...context,
};

const ThirdPartyContext = createContext(INITIAL_TP_CONTEXT);

export default ThirdPartyContext;
